import clsx from 'clsx';
import { ReactComponent as PlusIcon } from '../../assets/plus.svg';
import style from './style.module.scss';

export const PlusButton = ({ link, blank, text, onClick, classNames }) => (
    <div className={style.block}>
        <a
            href={link}
            target={blank ? '_blank' : undefined}
            rel="noreferrer"
            className={clsx(style.button, classNames)}
            onClick={onClick}
        >
            <PlusIcon />
            <span>{text}</span>
        </a>
    </div>
);
